import { createContext } from 'react';

export const FundingContext = createContext(null);
export const ACCOUNT_VALUE_START = [500000, 1000000, 2500000, 5000000, 10000000, 25000000, 50000000, 100000000];
export const START_TIME = 1672531200000;
export const END_TIME = 1704067199999;
export const RESULTS_LIMIT = 25;
